module.exports = __webpack_public_path__ + "static/media/icon-clock.b3cc631a.svg";